import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from "../network/Configurations";
import { setAutofillDescription } from "../actions/project";

const addProject = (request: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.ADD_PROJECT, request, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const updateProject = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .put(API_URL.UPDATE_PROJECT, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const getLocationList = (): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_LOCATION_LIST)
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const generateProject = (request) => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.GENERATE_PROJECT, request, { timeout: 120000 })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

export const ProjectService = {
  addProject,
  updateProject,
  getLocationList,
  generateProject,
};
